/**
 * Whether this deployment transcribes speech, which is what the composer's dictation control needs.
 *
 * The control is an occupant of a harness seat and receives only the seat's props, so the deployment's setting
 * reaches it here; the conversation page sets it from the session it loaded.
 */
import { create } from "zustand";

export const useTranscription = create<{ enabled: boolean }>(() => ({ enabled: false }));
